// extracted by mini-css-extract-plugin
export var attachment = "_nt-a";
export var emailContainer = "_nt-4";
export var emailContentPaddedContainer = "_nt-b";
export var emailHeader = "_nt-6";
export var emailIframe = "_nt-3";
export var emailInfoIcon = "_nt-9";
export var emailShortenedSummary = "_nt-e";
export var infoDropdown = "_nt-0";
export var infoRowBoundedContent = "_nt-d";
export var internal = "_nt-5";
export var merchant = "_nt-8";
export var messageInputContainer = "_nt-h";
export var normal = "_nt-7";
export var replyCard = "_nt-f";
export var subtleButton = "_nt-1";
export var subtleButtonIconContainer = "_nt-2";
export var toggleViewRepliesButton = "_nt-c";
export var wrappingText = "_nt-g";